// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Layout */
.manager-dashboard {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--gray-50);
}

.manager-container {
  display: flex;
  flex: 1 1;
}

.manager-content {
  flex: 1 1;
  padding: 2rem;
  margin-left: 10px;
  transition: margin-left 0.3s ease;
}

/* Header Styles */
.leave-requests-header {
  margin-bottom: 2rem;
}

.leave-requests-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.leave-requests-subtitle {
  font-size: 1rem;
  color: var(--gray-500);
  margin-bottom: 1.5rem;
}

/* Controls */
.leave-requests-controls {
  margin-bottom: 1.5rem;
}

.search-filter-container {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.search-box {
  position: relative;
  flex: 1 1;
  min-width: 250px;
}

.search-box i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #95a5a6;
}

.search-box input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s;
}

.search-box input:focus {
  border-color: var(--primary-400);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  outline: none;
}

.filter-dropdown select {
  padding: 0.75rem 1rem;
  border: 1px solid var(--gray-200);
  border-radius: 8px;
  font-size: 0.9rem;
  background-color: white;
  cursor: pointer;
  min-width: 180px;
}

.filter-dropdown select:focus {
  border-color: var(--primary-400);
  outline: none;
}

.leave-requests-table th {
  background-color: var(--primary-400);
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
  border-bottom: 2px solid #eee;
}

.leave-requests-table td {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}

.leave-requests-table tr:last-child td {
  border-bottom: none;
}

.leave-requests-table tr:hover {
  background-color: var(--gray-50);
}

/* Employee Info */
.employee-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.employee-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--primary-400);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.employee-details {
  display: flex;
  flex-direction: column;
}

.employee-name {
  font-weight: 500;
  color: var(--gray-800);
}

.employee-id {
  font-size: 0.8rem;
  color: var(--gray-500);
}

/* Status Badges */
.status-badge {
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
}

.status-pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-approved {
  background-color: #d4edda;
  color: #155724;
}

.status-rejected {
  background-color: #f8d7da;
  color: #721c24;
}

/* Status Select */
.status-select {
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid var(--gray-200);
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
}

.status-select:focus {
  outline: none;
  border-color: var(--primary-400);
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.status-select.pending {
  background-color: #fff3cd;
}

.status-select.approved {
  background-color: #d4edda;
}

.status-select.rejected {
  background-color: #f8d7da;
}

/* Date Range */
.date-range-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.date {
  font-weight: 500;
  color: var(--gray-800);
}

.date-separator {
  color: #95a5a6;
  font-size: 0.8rem;
  text-align: center;
}

/* Reason Text */
.reason-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid var(--primary-400);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.empty-state img {
  width: 150px;
  height: 150px;
  margin-bottom: 1.5rem;
  opacity: 0.7;
}

.empty-state h3 {
  font-size: 1.2rem;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.empty-state p {
  color: var(--gray-500);
  font-size: 0.9rem;
}

/* Alert */
.alert {
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1.5rem;
}

.alert-error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Leave Cards (Mobile View) */
.leave-requests-cards {
  display: none;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.leave-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 1.25rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}

.card-body {
  margin-bottom: 1rem;
}

.card-row {
  display: flex;
  margin-bottom: 0.75rem;
}

.card-label {
  font-weight: 500;
  color: var(--gray-800);
  min-width: 100px;
  font-size: 0.9rem;
}

.card-value {
  color: #34495e;
  flex: 1 1;
  font-size: 0.9rem;
}

.card-footer {
  display: flex;
  justify-content: flex-end;
}

@media (min-width: 992px) {
  .leave-requests-table-container {
    display: block;
  }
  .leave-requests-cards {
    display: none;
  }
}

@media (max-width: 991px) {
  .manager-content {
    margin-left: 0;
    padding: 1.5rem;
  }

  .leave-requests-cards {
    display: grid;
  }

  .leave-requests-table-container {
    display: none;
  }
}

@media (max-width: 576px) {
  .search-filter-container {
    flex-direction: column;
    gap: 0.75rem;
  }

  .search-box,
  .filter-dropdown select {
    width: 100%;
  }

  .card-row {
    flex-direction: column;
    gap: 0.25rem;
  }

  .card-label {
    min-width: auto;
  }
}

.leave-requests-table td {
  padding: 12px 15px;
  border-top: 1px solid #e9ecef;
  vertical-align: middle;
  word-wrap: break-word;
}

.leave-requests-table tr:hover {
  background-color: var(--gray-50);
}

/* Employee Info */
.employee-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.employee-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--primary-500);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.employee-details {
  display: flex;
  flex-direction: column;
}

.employee-name {
  font-weight: 500;
  color: var(--gray-800);
}

.employee-id {
  font-size: 12px;
  color: #6c757d;
}

/* Date Range */
.date-range-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date-separator {
  color: #6c757d;
  font-size: 12px;
  align-self: center;
}

.date {
  white-space: nowrap;
}

/* Leave Reason */
.reason-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3em;
  line-height: 1.5;
}

/* Status Badge */
.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge.pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.approved {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.rejected {
  background-color: #f8d7da;
  color: #721c24;
}

/* Status Select */
.status-select {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  font-size: 14px;
  cursor: pointer;
  width: 100%;
  max-width: 120px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 10px;
}

.status-select.pending {
  border-color: #ffeeba;
  background-color: #fff3cd;
}

.status-select.approved {
  border-color: #c3e6cb;
  background-color: #d4edda;
}

.status-select.rejected {
  border-color: #f5c6cb;
  background-color: #f8d7da;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .leave-requests-table {
    min-width: 1000px;
  }

  .leave-requests-table-container {
    overflow-x: auto;
  }
}



















`, "",{"version":3,"sources":["webpack://./src/components/Leave/ManagerLeaveRequests.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yDAAif;EACjf,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Main Layout */\n.manager-dashboard {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: var(--gray-50);\n}\n\n.manager-container {\n  display: flex;\n  flex: 1;\n}\n\n.manager-content {\n  flex: 1;\n  padding: 2rem;\n  margin-left: 10px;\n  transition: margin-left 0.3s ease;\n}\n\n/* Header Styles */\n.leave-requests-header {\n  margin-bottom: 2rem;\n}\n\n.leave-requests-title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n.leave-requests-subtitle {\n  font-size: 1rem;\n  color: var(--gray-500);\n  margin-bottom: 1.5rem;\n}\n\n/* Controls */\n.leave-requests-controls {\n  margin-bottom: 1.5rem;\n}\n\n.search-filter-container {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.search-box {\n  position: relative;\n  flex: 1;\n  min-width: 250px;\n}\n\n.search-box i {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #95a5a6;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 2.5rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: all 0.3s;\n}\n\n.search-box input:focus {\n  border-color: var(--primary-400);\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n  outline: none;\n}\n\n.filter-dropdown select {\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background-color: white;\n  cursor: pointer;\n  min-width: 180px;\n}\n\n.filter-dropdown select:focus {\n  border-color: var(--primary-400);\n  outline: none;\n}\n\n.leave-requests-table th {\n  background-color: var(--primary-400);\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  border-bottom: 2px solid #eee;\n}\n\n.leave-requests-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #eee;\n  vertical-align: middle;\n}\n\n.leave-requests-table tr:last-child td {\n  border-bottom: none;\n}\n\n.leave-requests-table tr:hover {\n  background-color: var(--gray-50);\n}\n\n/* Employee Info */\n.employee-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.employee-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: var(--primary-400);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.employee-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.employee-name {\n  font-weight: 500;\n  color: var(--gray-800);\n}\n\n.employee-id {\n  font-size: 0.8rem;\n  color: var(--gray-500);\n}\n\n/* Status Badges */\n.status-badge {\n  padding: 0.35rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.status-pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* Status Select */\n.status-select {\n  padding: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid var(--gray-200);\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.status-select:focus {\n  outline: none;\n  border-color: var(--primary-400);\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n}\n\n.status-select.pending {\n  background-color: #fff3cd;\n}\n\n.status-select.approved {\n  background-color: #d4edda;\n}\n\n.status-select.rejected {\n  background-color: #f8d7da;\n}\n\n/* Date Range */\n.date-range-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.date {\n  font-weight: 500;\n  color: var(--gray-800);\n}\n\n.date-separator {\n  color: #95a5a6;\n  font-size: 0.8rem;\n  text-align: center;\n}\n\n/* Reason Text */\n.reason-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 250px;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid var(--primary-400);\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  text-align: center;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.empty-state img {\n  width: 150px;\n  height: 150px;\n  margin-bottom: 1.5rem;\n  opacity: 0.7;\n}\n\n.empty-state h3 {\n  font-size: 1.2rem;\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n.empty-state p {\n  color: var(--gray-500);\n  font-size: 0.9rem;\n}\n\n/* Alert */\n.alert {\n  padding: 1rem;\n  border-radius: 6px;\n  margin-bottom: 1.5rem;\n}\n\n.alert-error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Leave Cards (Mobile View) */\n.leave-requests-cards {\n  display: none;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n.leave-card {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 1.25rem;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #eee;\n}\n\n.card-body {\n  margin-bottom: 1rem;\n}\n\n.card-row {\n  display: flex;\n  margin-bottom: 0.75rem;\n}\n\n.card-label {\n  font-weight: 500;\n  color: var(--gray-800);\n  min-width: 100px;\n  font-size: 0.9rem;\n}\n\n.card-value {\n  color: #34495e;\n  flex: 1;\n  font-size: 0.9rem;\n}\n\n.card-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (min-width: 992px) {\n  .leave-requests-table-container {\n    display: block;\n  }\n  .leave-requests-cards {\n    display: none;\n  }\n}\n\n@media (max-width: 991px) {\n  .manager-content {\n    margin-left: 0;\n    padding: 1.5rem;\n  }\n\n  .leave-requests-cards {\n    display: grid;\n  }\n\n  .leave-requests-table-container {\n    display: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .search-filter-container {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .search-box,\n  .filter-dropdown select {\n    width: 100%;\n  }\n\n  .card-row {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n\n  .card-label {\n    min-width: auto;\n  }\n}\n\n.leave-requests-table td {\n  padding: 12px 15px;\n  border-top: 1px solid #e9ecef;\n  vertical-align: middle;\n  word-wrap: break-word;\n}\n\n.leave-requests-table tr:hover {\n  background-color: var(--gray-50);\n}\n\n/* Employee Info */\n.employee-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.employee-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: var(--primary-500);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.employee-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.employee-name {\n  font-weight: 500;\n  color: var(--gray-800);\n}\n\n.employee-id {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n/* Date Range */\n.date-range-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.date-separator {\n  color: #6c757d;\n  font-size: 12px;\n  align-self: center;\n}\n\n.date {\n  white-space: nowrap;\n}\n\n/* Leave Reason */\n.reason-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-height: 3em;\n  line-height: 1.5;\n}\n\n/* Status Badge */\n.status-badge {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.status-badge.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-badge.approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.status-badge.rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* Status Select */\n.status-select {\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  font-size: 14px;\n  cursor: pointer;\n  width: 100%;\n  max-width: 120px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 10px;\n}\n\n.status-select.pending {\n  border-color: #ffeeba;\n  background-color: #fff3cd;\n}\n\n.status-select.approved {\n  border-color: #c3e6cb;\n  background-color: #d4edda;\n}\n\n.status-select.rejected {\n  border-color: #f5c6cb;\n  background-color: #f8d7da;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .leave-requests-table {\n    min-width: 1000px;\n  }\n\n  .leave-requests-table-container {\n    overflow-x: auto;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
